// Toast (UI_SPEC §4.4): ngoại lệ duy nhất, chỉ cho gacha. Tự tắt sau 2,4s, không bắt chạm.
import type { JSX } from 'preact';
import { useEffect } from 'preact/hooks';
import { t } from '@i18n/t';
import { clearToast, toastState, windows } from '@state/modules/ui';

export const TOAST_MS = 2400;

export function ToastHost(): JSX.Element | null {
  const s = toastState.value;
  useEffect(() => {
    if (!s) return;
    const id = setTimeout(() => clearToast(s.seq), TOAST_MS);
    return () => clearTimeout(id);
  }, [s]);
  if (!s) return null;
  return (
    <div
      key={s.seq}
      class={windows.value.length > 0 ? 'ht-toast lifted' : 'ht-toast'}
      role="status"
      aria-live="polite"
      data-id="toast"
    >
      {t(s.textKey)}
    </div>
  );
}
